import { useCallback, useState } from 'react';

import type { ThreadTarget } from './threads.schema';

export interface ThreadsModalState {
    target: ThreadTarget | null;
    open: (target: ThreadTarget) => void;
    close: () => void;
}

export function useThreadsModal(): ThreadsModalState {
    const [target, setTarget] = useState<ThreadTarget | null>(null);

    const open = useCallback((next: ThreadTarget) => setTarget(next), []);
    const close = useCallback(() => setTarget(null), []);

    return { target, open, close };
}
